<template>
	<v-dialog :model-value="Boolean(dialog)" max-width="440" persistent no-click-animation class="nav-legacy-dialog">
		<v-card v-if="dialog" rounded="xl" class="nav-dialog" @keydown.esc.stop="onEscape">
			<div class="nav-legacy-dialog__head">
				<v-img v-if="dialog.imageUrl" :src="dialog.imageUrl" max-height="96" max-width="96" class="nav-legacy-dialog__image" />
				<v-icon v-else-if="icon" :color="icon.color" size="48">{{ icon.name }}</v-icon>
			</div>
			<v-card-title v-if="dialog.title" class="nav-legacy-dialog__title">{{ dialog.title }}</v-card-title>
			<v-card-text>
				<p v-if="dialog.text" class="nav-dialog__text">{{ dialog.text }}</p>
				<v-text-field v-if="dialog.type === 'input'" v-model="inputValue" :type="dialog.inputType" :placeholder="dialog.inputPlaceholder" :error-messages="dialog.inputError ? [dialog.inputError] : []" variant="outlined" autofocus @keydown.enter="confirm" />
			</v-card-text>
			<v-card-actions class="nav-legacy-dialog__actions">
				<v-btn v-if="dialog.showCancelButton" variant="text" @click="cancelLegacyDialog">{{ dialog.cancelText }}</v-btn>
				<v-btn v-if="dialog.showConfirmButton" color="primary" variant="flat" @click="confirm">{{ dialog.confirmText }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-snackbar-queue v-model="legacyDialogs.toasts" location="top right" closable rounded="xl" />
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { cancelLegacyDialog, confirmLegacyDialog, legacyDialogs } from '@/iframe/legacyDialogs';

const ICONS = {
	success: { name: 'check_circle', color: 'success' },
	error: { name: 'error', color: 'error' },
	warning: { name: 'warning', color: 'warning' },
	info: { name: 'info', color: 'info' },
};

const dialog = computed(() => legacyDialogs.current);
const icon = computed(() => ICONS[dialog.value?.type] ?? null);
const inputValue = ref('');

watch(
	() => dialog.value?.id,
	() => {
		inputValue.value = dialog.value?.inputValue ?? '';
	}
);

const confirm = () => confirmLegacyDialog(inputValue.value);

const onEscape = () => {
	if (dialog.value?.allowEscapeKey) cancelLegacyDialog();
};
</script>
